import { YOUTUBE_PLAY_ICON } from '@constants/assets-path';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { getAssetUrl } from './common.utils';

export const getYoutubeVideoId = (youtubeUrl: string) => {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\??v?=?))([^#\&\?]*).*/;
  var match = youtubeUrl.match(regExp);
  return match && match[7].length ? match[7] : '';
};

export const getYoutubeSrcDoc = (
  youtubeUrl: string,
  youtubePreviewImg: string,
) => {
  const iconWidth = 68;
  const iconHeight = 68;
  const iconUrl = getAssetUrl('blog', YOUTUBE_PLAY_ICON);
  const youtubePlayIcon = `<img src="${iconUrl}" loading="lazy" class="play-icon" width="${iconWidth}" height="${iconHeight}" />`;
  return `<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}.preview-img{position:absolute;width:100%;top:0;bottom:0;margin:auto;height:100%;object-fit:cover;}div{display:flex;width:100%;height:100%;justify-content:center;align-items:center;position:absolute}</style><a href=${youtubeUrl}><img src=${youtubePreviewImg} class="preview-img" loading="lazy" alt='Video The Dark Knight Rises: What Went Wrong? – Wisecrack Edition'><div>${youtubePlayIcon}</div></a>`;
};

export const getPreviewUrl = (ytVideoId: string, platform: PlatformType) => {
  let qualityPath = 'hqdefault';
  switch (platform) {
    case PlatformType.Desktop:
      qualityPath = 'hqdefault';
      break;
    default:
      qualityPath = 'mqdefault';
      break;
  }
  return `https://img.youtube.com/vi/${ytVideoId}/${qualityPath}.jpg`;
};
